import { createCustomerAccessToken } from "@app/lib/authentication";
import { updateCustomer } from "@app/lib/customer";
import Cookies from "js-cookie";

class AccountOverview extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const edit = new URLSearchParams(window.location.search).get("edit");
    const allElements = this.querySelectorAll(".element--overview, .element--update-password, .element--edit-account");

    switch (edit) {
      case "account":
        allElements.forEach((element) => {
          element.classList.add("!hidden");
        });
        this.querySelectorAll(".element--edit-account, .element--edit")?.forEach((element) => {
          element.classList.remove("!hidden");
        });
        break;

      case "update-password":
        allElements.forEach((element) => {
          element.classList.add("!hidden");
        });
        this.querySelectorAll(".element--update-password, .element--edit")?.forEach((element) => {
          element.classList.remove("!hidden");
        });
        break;

      default:
        allElements.forEach((element) => {
          element.classList.remove("!hidden");
        });
        this.querySelectorAll(".element--edit-account, .element--update-password")?.forEach((element) => {
          element.classList.add("!hidden");
        });
    }

    document.querySelector(".account-details-form")?.addEventListener("submit", async (e: any) => {
      e.preventDefault();

      const form = e.target.closest("form");
      const data = new FormData(form) as any;
      const submitButton = form.querySelector("button[type='submit']");
      const accountDetailsFormSuccessMessage = form.querySelector(".form-success-message");

      window.inputErrorClearAll(form);
      submitButton.disabled = true;
      accountDetailsFormSuccessMessage.classList.add("hidden");

      const { customerUserErrors } = await updateCustomer({
        acceptsMarketing: data.get("consent") === "on",
        email: data.get("email") || undefined,
        firstName: data.get("first_name") || undefined,
        lastName: data.get("last_name") || undefined,
        phone: data.get("phone")?.replace(/^04/, "+614").replace(/ /g, "") || undefined,
      });

      if (customerUserErrors.length > 0) {
        customerUserErrors.forEach((error: any) => {
          const input = form.querySelector(
            `[name="${error.field[error.field.length - 1]}"]`,
          ) as HTMLInputElement | null;
          const inputWrapper = input?.closest(".snippet-input") as HTMLDivElement | null;
          if (inputWrapper) window.inputError(inputWrapper, error.message);
        });
      } else {
        accountDetailsFormSuccessMessage.classList.remove("hidden");
        const y = accountDetailsFormSuccessMessage.getBoundingClientRect().top + window.scrollY - 150;
        window.scrollTo({ top: y, behavior: "smooth" });
      }

      submitButton.disabled = false;
    });

    document.querySelector(".update-password-form")?.addEventListener("submit", async (e: any) => {
      e.preventDefault();

      const form = e.target.closest("form");
      const data = new FormData(form) as any;

      window.inputErrorClearAll(form);
      form.querySelector("button[type='submit']").disabled = true;

      const password = data.get("password");

      // Verify new passwords match
      if (password !== data.get("password_confirmation")) {
        const input = form.querySelector('[name="password_confirmation"]') as HTMLInputElement | null;
        const inputWrapper = input?.closest(".snippet-input") as HTMLDivElement | null;
        if (inputWrapper) window.inputError(inputWrapper, "Passwords do not match");
        form.querySelector("button[type='submit']").disabled = false;
        return;
      }

      // Check password strength
      if (password.length < 8 || /[A-Z]/.test(password) === false || /[^A-Z]/i.test(password) === false) {
        const input = form.querySelector('[name="password"]') as HTMLInputElement | null;
        const inputWrapper = input?.closest(".snippet-input") as HTMLDivElement | null;
        if (inputWrapper)
          window.inputError(
            inputWrapper,
            "Your password needs at least 8 characters with an UPPERCASE character and a number (1-9) or a special character (!@#$%^&*)",
          );
        form.querySelector("button[type='submit']").disabled = false;
        return;
      }

      // First verify the old password
      const { customerUserErrors: customerUserErrorsOldPassword } = await createCustomerAccessToken(
        window.customer?.email || "",
        data.get("old_password"),
      );

      if (customerUserErrorsOldPassword.length > 0) {
        const input = form.querySelector('[name="old_password"]') as HTMLInputElement | null;
        const inputWrapper = input?.closest(".snippet-input") as HTMLDivElement | null;
        if (inputWrapper) window.inputError(inputWrapper, "Wrong password");
        form.querySelector("button[type='submit']").disabled = false;
        return;
      }

      // Update the user's password
      const { customerUserErrors } = await updateCustomer({
        password: data.get("password"),
      });

      if (customerUserErrors.length > 0) {
        customerUserErrors.forEach((error: any) => {
          const input = form.querySelector(
            `[name="${error.field[error.field.length - 1]}"]`,
          ) as HTMLInputElement | null;
          const inputWrapper = input?.closest(".snippet-input") as HTMLDivElement | null;
          if (inputWrapper) window.inputError(inputWrapper, error.message);
        });

        form.querySelector("button[type='submit']").disabled = false;
      } else {
        Cookies.set("passwordUpdated", 'true');
        window.location.reload();
      }
    });
  }
}

window.customElements.define("account-overview", AccountOverview);
